import styled from 'styled-components';
import { H2 } from '../../styles/textTags';
import { BREAKPOINTS, COLORS } from '../../styles/variables';

const Title = ({ children }) => {
  return (
    <TitleWr>
      <img src='/imgs/star.png' alt='' />
      <EventH2>{children}</EventH2>
      <img src='/imgs/star.png' alt='' />
    </TitleWr>
  );
};

const TitleWr = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  margin: 50px 0 24px;

  img {
    pointer-events: none;
    width: 40px;
    height: 40px;
  }

  @media ${BREAKPOINTS.laptop} {
    gap: 0.83vw;

    margin: 3.47vw 0 1.67vw;
    img {
      width: 2.78vw;
      height: 2.78vw;
    }
  }

  @media ${BREAKPOINTS.mobile} {
    gap: 1.5vw;

    margin: 3.33vw 0 5.83vw;
    img {
      width: 5vw;
      height: 5vw;
    }
  }
`;

const EventH2 = styled(H2)`
  font-size: 48px;
  color: ${COLORS.black};
  @media ${BREAKPOINTS.laptop} {
    font-size: 3.33vw;
  }

  @media ${BREAKPOINTS.mobile} {
    font-size: 4.58vw;
  }
`;

export default Title;
